import { useContext, useRef } from "react";

import Context from "features/allocations/contexts/Context";
import Loading from "shared/components/feedback/loading/Loading";
import {
    MessageWrapper,
    FooterContainer,
} from "./FooterPanel.styles";

const loadingMessage = (message) => {
    return (
        <MessageWrapper>
            <Loading text={message} />
        </MessageWrapper>
    );
};

const AllocationsFooter = () => {
    const { isLoadingMore } = useContext(Context);
    const footerContainer = useRef();

    const gridFooterToShow = () => {
        if (isLoadingMore.loading) {
            return loadingMessage(isLoadingMore.message);
        }
    };

    return <FooterContainer ref={footerContainer}>{gridFooterToShow()}</FooterContainer>;
};

AllocationsFooter.propTypes = {};

export default AllocationsFooter;
